// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SessionAdd_wrapper__VzwGH"};